import { usePathname } from 'next/navigation'
import { useEffect, useRef } from 'react'

// Fixes open NextJS issue: https://github.com/vercel/next.js/issues/64441
export const useScrollFix = () => {
  const pathname = usePathname()
  const isStatePopped = useRef(false)
  const isInitialLoad = useRef(true)

  // Handling the scroll position to ensure clicking on the links
  // scrolls the page to the top with the sticky positioned navbar.
  useEffect(() => {
    const onPopState = () => (isStatePopped.current = true)

    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (!isStatePopped.current && !isInitialLoad.current) {
        // navigation occurred without pressing
        // the browser's back or forward buttons
        window.scrollTo(0, 0)
      } else {
        isStatePopped.current = false
        isInitialLoad.current = false
      }
    }, 0)
  }, [pathname])
}
